export default "__VITE_ASSET__C0Bh9pbq__"